import BaseStatisticsTable from './Table';

export default BaseStatisticsTable;
